import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useBoolean, useInput } from "react-hanger";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import EmailIcon from "@mui/icons-material/Email";
import ErrorIcon from "@mui/icons-material/Error";
import PersonIcon from "@mui/icons-material/Person";

import { csActions } from "../../../../../redux/actions";

const UnconnectedStep2Content = (props) => {
  const name = useInput(props.clientName || "");
  const email = useInput(props.clientEmail || "");
  const isEmailValid = useBoolean(false);

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  }

  const handleContinue = () => {
    props.setEmail(props.orderId, email.value);
  }

  useEffect(() => {
    if (props.isEmailSet) {
      props.handleNextStep();
    }
  }, [props.isEmailSet])

  useEffect(() => {
    if (validateEmail(email.value))
      isEmailValid.setTrue();
    else
      isEmailValid.setFalse();
  }, [email]);

  return (
    <>
      <TextField
        fullWidth
        variant="outlined"
        label="Name"
        value={ name.value }
        onChange={ name.onChange }
        disabled={true}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <PersonIcon />
            </InputAdornment>
          ),
        }}
        sx={{ marginBottom: "16px" }}
      />
      <TextField
        fullWidth
        variant="outlined"
        label="Email"
        value={ email.value }
        onChange={ email.onChange }
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <EmailIcon />
            </InputAdornment>
          ),
        }}
      />
      <p></p>
      {props.isError &&
        <Grid container direction="row" alignItems="center" justifyContent="center" spacing="2px">
          <Grid item>
            <ErrorIcon color="error" fontSize="small" />
          </Grid>
          <Grid item>
            <Typography variant="caption" color="error">{props.errorMessage}</Typography>
          </Grid>
        </Grid>
      }
      <p></p>
      <div>
        <Button
          variant="contained"
          disabled={!isEmailValid.value || props.isSettingEmail}
          onClick={handleContinue}
          sx={{ mt: 1, mr: 1 }}
        >
          Continue
        </Button>
        <Button
          variant="outlined"
          disabled={false}
          onClick={props.handleBackStep}
          sx={{ mt: 1, mr: 1 }}
        >
          Back
        </Button>
      </div>
    </>
  )
}

const mapState = (state) => {
  const {
    orderId,
    clientEmail,
    isSettingEmail,
    isEmailSet,
    isError,
    errorMessage,
  } = state.cs;
  return {
    orderId,
    clientName: state.cs[0].clientName,
    clientEmail,
    isSettingEmail,
    isEmailSet,
    isError,
    errorMessage,
  };
};

const actionCreators = {
  setEmail: csActions.setEmail,
};

export const Step2Content = connect(mapState, actionCreators)(UnconnectedStep2Content);